import React, { useEffect, useRef } from 'react';

import { useField } from '@unform/core';

import { Container, Textarea, MsgError } from './styles';

export default function InputComponent({ name, ...rest }) {
  const inputRef = useRef(null);
  const {
    fieldName, defaultValue = '', registerField, error,
  } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container>
      <Textarea ref={inputRef} defaultValue={defaultValue} {...rest} />
      <MsgError>{error}</MsgError>
    </Container>
  );
}
